import React from "react";
import { useEffect } from "react";
import { Box, Container, Heading, Text, Button, Flex, Spinner} from "@radix-ui/themes";

const SixMonthTrialContents: React.FC = () => {
  return (
    <Box>
      <Container size="3" px="6" py = "9">
        <Flex direction="column" align = "center" gapY="4">
            <Heading weight="bold" align = "center" size="8">Automatically redirecting...</Heading>
            <Spinner/>
        </Flex>

        <Flex direction="column" py="8">
                <Button color="green" variant="soft" mt="4" onClick={() => window.location.href = "livefootballontv://home?sixmonthtrial=true"}>
                    Activate
                </Button>
                <Text align="center" weight="light" size="2" color="gray" my="2">Click above if you are not automatically redirected </Text>
        </Flex>
      </Container>
    </Box>  
  );
};

function SixMonthTrial() {
  useEffect(() => {
    window.location.href = "livefootballontv://home?sixmonthtrial=true";
  }, []);

  return <SixMonthTrialContents/>;
}

export default SixMonthTrial;